import React from 'react';

export const TiktokIcon = () => {
    return (
        <svg
            width="20"
            height="21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 20.25a5.75 5.75 0 0 0 5.75-5.75v-8A5.75 5.75 0 0 0 14 .75H6A5.75 5.75 0 0 0 .25 6.5v8A5.75 5.75 0 0 0 6 20.25h8ZM11.71 4.26a.75.75 0 0 0-1.46.24v9A2.25 2.25 0 1 1 8 11.25a.75.75 0 1 0 0-1.5 3.75 3.75 0 1 0 3.75 3.75V6.96A4.7 4.7 0 0 0 15 8.25a.75.75 0 1 0 0-1.5 3.2 3.2 0 0 1-2.26-.92 4.13 4.13 0 0 1-1.03-1.57Z"
                fill="#F8F6DF"
            />
        </svg>
    );
};
